import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import type { SalesByStatus } from '../../types/dashboard.types';

interface SalesByStatusChartProps {
  data: SalesByStatus;
}

const COLORS = {
  pending: '#f59e0b', // Amber
  approved: '#10b981', // Green
  rejected: '#ef4444', // Red
};

export const SalesByStatusChart: React.FC<SalesByStatusChartProps> = ({ data }) => {
  const chartData = [
    { name: 'Pending', value: data.pending },
    { name: 'Approved', value: data.approved },
    { name: 'Rejected', value: data.rejected },
  ].filter((item) => item.value > 0);

  if (chartData.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">Sales by Status</h3>
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No status data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Sales by Status</h3>
      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${((percent || 0) * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[entry.name.toLowerCase() as keyof typeof COLORS]}
              />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};
